module.exports = __webpack_public_path__ + "Cubano-Regular.1d65b5646a9a805c62b0.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/Cubano-Regular.otf
// module id = 1377
// module chunks = 2